module.exports = __webpack_public_path__ + "img/R06_OFF.561e2d2a.jpg";